module.exports = __webpack_public_path__ + "static/media/538JamesPBrawleyDrNW_2018-06-12_175.a378c079.jpg";